import React from "react";

import { useTranslation } from "react-i18next";

const TermsBody = () => {
  const { t } = useTranslation("terms");
  return (
    <div className="container mx-auto py-12 md:py-24 ">
      <div className="space-y-5 mb-4 md:mb-16">
        <h3 className="text-center text-3xl lg:text-[56px] lg:leading-[4rem] font-test-sohne-medium">
          {t("termsHeading")}
        </h3>
        <div className="space-y-6">
          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              1. Introduction
            </h4>
            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              These Terms and Conditions ("Terms") outlined on this webpage
              constitute a legal agreement between you, as a potential user of
              Smartcomply services/products, and Smartcomply Technology
              Solutions Limited (referred to as "Smartcomply", "we", "our", or
              "us"). These Terms govern your access to and use of Smartcomply's
              services, which include all pages on the Smartcomply website, web
              applications, and other related products and services
              (collectively referred to as the "Services") By using the
              Services/Products, these Terms apply to you in full and take
              effect immediately. By accessing or using any of the Services, you
              explicitly agree to all the terms and conditions stated here,
              without any limitations or exceptions, including our Privacy
              Notice. If you do not agree with any part of these Terms, you must
              not use any of the Services/Products.
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              2. Who are we?
            </h4>
            <p className="">
              We are Smartcomply Technology Solutions Limited (hereinafter
              referred to as "Smartcomply"). Our address is The Bunker Building
              279 Herbert Macaulay Way Yaba, Lagos, Nigeria. You can contact us
              at the above address, by email at{" "}
              <a href="mailto:cs@smartcomply.com">cs@smartcomply.com</a> or by
              telephone on +234 813 326 2024.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              3. Governing Language
            </h4>
            <p className="">
              English language will be the governing language of these Terms and
              all communications between Smartcomply and you.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              4. Who May Use Our Services?
            </h4>
            <p className="">
              You are permitted to use the Services/Products only if you agree
              to enter into a binding contract with Smartcomply and are not
              prohibited from receiving services under the laws of the relevant
              jurisdiction. If you are accepting these Terms and using the
              Services on behalf of a company, business, or organization, you
              confirm and guarantee that you have the authority to do so.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              5. Age Restriction
            </h4>
            <p className="">
              Our website and Services/Products are intended for individuals
              aged 18 and above. You are only allowed to use the Services if you
              are 18 years or older. We do not knowingly provide services to
              individuals under the age of 18.{" "}
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              6. Intellectual Property
            </h4>
            <p className="">
              Unless stated otherwise, Smartcomply and/or its licensors own the
              intellectual property rights to the materials on the website,
              subject to the license outlined below. All text, formatting
              (including, but not limited to, the arrangement of materials on
              the Smartcomply websites/webpages), graphics, animations, tools,
              advertisements, music, videos, articles, sound, copy, trade names,
              logos, and other materials and information on the website are
              protected by the intellectual property rights of Smartcomply, its
              affiliates, licensors, and licensees (collectively referred to as
              the "Content"). We do not grant you any rights, licenses, titles,
              or interests in our intellectual property, whether you have access
              to it or not. The Content may not be copied, reverse-engineered,
              decompiled, disassembled, modified, or reposted on other websites.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              7. License to Use Our Website
            </h4>
            <p className="">
              We grant you a limited, non-exclusive, non-transferable license to
              access and use the Services in manners set forth by the terms in
              this Agreement.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              8. Limitation of Liability
            </h4>
            <p className="">
              To the fullest extent permitted by law, Smartcomply shall not be
              liable for any indirect, incidental, special, or consequential
              damages arising from the your use of the Services/Products.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              9. Governing Law
            </h4>
            <p className="">
              These Terms of Use and any disputes arising out of or related to
              the use of this website or web application shall be governed by
              and construed in accordance with the laws of the Federal Republic
              of Nigeria, without regard to its conflict of law principles. By
              accessing or using our services/products, you agree that any legal
              action or proceedings related to this agreement shall be subject
              to the exclusive jurisdiction of the courts of Nigeria.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              10. Changes to These Terms of Use
            </h4>
            <p className="">
              We reserve the right, at Our sole discretion, to modify or replace
              these Terms at any time. If a revision is material, we will
              provide notice to users on our “Terms of Use” page. What
              constitutes a material change will be determined at Our sole
              discretion. By continuing to access or use Our Service/Product
              after those revisions become effective, you agree to be bound by
              the revised terms. If You do not agree to the new terms, in whole
              or in part, please stop using the website and the Service/Product.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-test-sohne-medium text-base md:text-lg text-opacity-60">
              Contact Us
            </h4>
            <p className="">
              If you have any questions or concerns about these Terms of Use,
              you can contact us:
            </p>
            <ul className="list-disc text-sm md:text-[15px] text-CharcoalGrey px-4">
              <li>By telephone: +234 813 326 2024</li>
              <li>
                By sending us an email:{" "}
                <a href="mailto:cs@smartcomply.com">cs@smartcomply.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsBody;
